<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7UZJV1/tc-custom/9781625676924.jpg?1726444214930" alt="This image is the cover for the book Smoke and Shadows, Smoke"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Smoke and Shadows, Smoke
      </h1>
      <p class="bookDescription body article font2">
        <b>Tanya Huff, bestselling author of the Blood Price books, starts a new series where a street kid-turned-production assistant must juggle his vampire ex, a crush on a hot straight actor, and the potential end of the world…</b><br/><br/>Working on a direct-to-syndication show about a vampire detective doesn’t much compare to Tony Foster’s past as an actual vampire’s lover. True, he’s still wrangling beautiful people with big egos and the power to crush him, but there are far fewer demons, and TV blood is just corn syrup.<br/><br/>When shadows on set start moving independent of the people they’re supposed to be attached to, though, Tony can’t dismiss it as a trick of the light. Especially when he finds the beauty of the week dead in a locked dressing room. Before long, he’s discovered the head of the special effects department is an actual wizard, and brought in his ex, the vampire Henry Fitzroy, to help defend against an attack so terrifying survival seems unlikely. Tony will have to assist his butt off to give them anything like a chance. But being thrust into a spotlight doesn’t make him a hero…
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tanya Huff
      </h2>
      
      <p class="authorDescription body article">Tanya Huff lives in rural Ontario with her wife Fiona Patton, five cats, and an increasing number of fish. Her 32 novels and 83 short stories include horror, heroic fantasy, urban fantasy, comedy, and space opera. Her BLOOD series was turned into the 22-episode <em>Blood Ties</em> and writing episode nine allowed her to finally use her degree in Radio & Television Arts. Many of her short stories are available as eCollections. She’s on Twitter at @TanyaHuff and Facebook as Tanya Huff. She has never used her Instagram account and isn’t sure why she has it.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?927ba7ba